import idMaker from "../util/idMaker.js";
export function adapterConfigCacheKey(conf = {}) {
    return conf.type && conf.adapterId
        ? `${conf.type}-${conf.adapterId}`
        : `${idMaker(conf)}`;
}
